exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.virtual-table[data-v-2e9b5614] {\n  height: 500px; /* 必须指定高度 */\n}\n", ""]);

// exports
